import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import fileDownload from 'js-file-download';

export const loadInvoices = createAsyncThunk(
  'invoices/loadInvoices',
  async ({ page = 1, searchValue = '', organization = null }, { rejectWithValue }) => {
    try {
      let url = `invoices/invoices/?page=${page}&page_size=100`;
      if (searchValue) url += `&search=${searchValue}`;
      if (organization) url += `&organization=${organization}`;
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const downloadInvoice = createAsyncThunk(
  'invoices/downloadInvoice',
  async ({ id, is_preview, unique_name }, { rejectWithValue }) => {
    try {
      const data = { is_preview, unique_name };
      const response = await axios.post(`/invoices/invoices/${id}/invoiceDownload/`, data, {
        responseType: 'blob',
      });
      fileDownload(response.data, 'template.pdf');
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const invoicesSlice = createSlice({
  name: 'invoices',
  initialState: {
    invoices: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadInvoices.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload;
      })
      .addCase(loadInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadInvoice.fulfilled, (state) => {
        state.loading = false;
      });
  },
});

export default invoicesSlice.reducer;
